// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { miniMyAccountStyles } from "@werner/App/Components/MiniMyAccount/MiniMyAccount";
import { myAccountViewStyles } from "@werner/Overrides/Widgets/MyAccount/MyAccountView";
import { xScreen } from "@werner/XDL/Utilities";
import { css } from "styled-components";

myAccountViewStyles.quickLinksGridItem = {
    width: [12, 12, 12, 4, 4],
    css: css`
        &&&& {
            ${xScreen("lt", "md")} {
                display: none;
            }
        }
    `,
};
myAccountViewStyles.mainSectionGridItem = {
    width: [12, 12, 12, 8, 8],
};
myAccountViewStyles.accountMessagesGridItem = {
    width: 12,
    css: css`
        flex-direction: column;
        gap: 12px;
        align-items: flex-end;
    `,
};
myAccountViewStyles.dashboardWidgetsGridItem = { width: 12 };
myAccountViewStyles.miniMyAccountGridItem = {
    width: 12,
    css: css`
        &&&& {
            display: none;
            ${xScreen("lt", "md")} {
                display: block;
            }
        }
    `,
};

myAccountViewStyles.myAccountGridContainer = {
    gap: 30,
};

myAccountViewStyles.miniMyAccountStyles = {
    infoGridContainer: {
        ...miniMyAccountStyles.infoGridContainer,
        css: css`
            ${miniMyAccountStyles.infoGridContainer?.css}
            overflow-y: unset;
            overflow-x: unset;
            padding: 0;
        `,
    },
};
